import { CheckboxQuestionProvider } from '../../question-types/CheckboxQuestionProvider';
import { NameQuestionProvider } from '../../question-types/NameQuestionProvider';
import { YesNoQuestionProvider } from '../../question-types/YesNoQuestionProvider';
import { IQuestion } from '../IQuestion';
import { IQuestionProvider } from './IQuestionProvider';
import { MiniWizardViewModel } from '../MiniWizardViewModel';
import { AvatarQuestionProvider } from '../../question-types/AvatarQuestionProvider';

export class CompositeQuestionProvider {
    static inject = () => [
        YesNoQuestionProvider,
        CheckboxQuestionProvider,
        NameQuestionProvider,
        AvatarQuestionProvider
    ];
    private providers: IQuestionProvider[];
    constructor(...providers: IQuestionProvider[]){
        this.providers = providers;
    }

    private getProvider = (question: IQuestion) => {
        const provider = this.providers.find(p => p.questionType === question.questionType);
        if(!provider){
            throw new Error(`no provider for question type ${question.questionType}. Did you forget to add the provider to CompositeQuestionProvider.`);
        }
        return provider;
    };

    validate = (question: IQuestion) => {
        return this.getProvider(question).validate(question);
    };

    render = (question: IQuestion, wizard: MiniWizardViewModel) => {
        return this.getProvider(question).render(question, wizard);
    };
}
